import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CTAButton from '../../../../../CTAButton/CTAButton';

import { TXTWCL_Deposit, TXTWCL_EUR_N0, TXTWCL_Max_30 } from './Deposit.messages.json';
import { container, cta, description } from './Deposit.scss';

export const Deposit: React.FC = () => (
  <div className={container}>
    <div className={description}>
      <strong>
        <Translation {...TXTWCL_Deposit} />
      </strong>
      <h3>
        <Translation {...TXTWCL_Max_30} /> <Translation {...TXTWCL_EUR_N0} values={{ 0: 800 }} />
      </h3>
    </div>
    <div className={cta}>
      <CTAButton type="submit" translation={TXTWCL_Deposit} />
    </div>
  </div>
);
